(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishUsaHighSchoolLinePack = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function normHex(x){ if(!x) return '#FFFFFF'; x=String(x).trim(); if(x[0] !== '#') x='#'+x; return x.toUpperCase(); }

  (function ensureUsaHighSchoolLines(){
    if (GLOBAL && GLOBAL.SwishUsaHighSchoolLines) return;
    const config = GLOBAL && GLOBAL.SwishCBConfig;
    const create = config && config.createBasketballProceduralLineAPI;
    if (typeof create !== 'function') {
      try { console.error('[SwishUsaHighSchoolLines] procedural basketball helper unavailable'); } catch (_) {}
      GLOBAL.SwishUsaHighSchoolLines = {
        ready: Promise.resolve(),
        design: { W: 15240, L: 25603.2 },
        draw: function(){}
      };
      return;
    }
    GLOBAL.SwishUsaHighSchoolLines = create({
      rulesetId: 'US_HIGHSCHOOL',
      lengthM: 25.6032,
      widthM: 15.24
    });
  })();

  function draw2D(ctx, x0, y0, cw, ch, color, opts) {
    if (GLOBAL.SwishUsaHighSchoolLines && typeof GLOBAL.SwishUsaHighSchoolLines.draw === 'function') {
      GLOBAL.SwishUsaHighSchoolLines.draw(ctx, x0, y0, cw, ch, normHex(color), Object.assign({ only: null, hideCenter: false }, opts || {}));
    }
  }

  function defaults() { return { length: 30, width: 18 }; }

  const linesApi = GLOBAL.SwishUsaHighSchoolLines || {};

  return {
    id: 'usahs.linepack',
    draw2D: draw2D,
    draw: draw2D,
    design: linesApi.design || { W: 15240, L: 25603.2 },
    ready: linesApi.ready || Promise.resolve(),
    defaults: defaults
  };
}));
